import {
    DecimalNullableRelatedPropertyValue,
    ProductDetailViewModel,
    RelatedProperties,
    StringRelatedPropertyValue
} from '@models/api-search.models';

export const getVariantMatch = (
    variant: ProductDetailViewModel,
    key: keyof RelatedProperties,
    value: StringRelatedPropertyValue | DecimalNullableRelatedPropertyValue
): boolean | void => {
    // Check to see if the variant has the property that was changed. e.g. variant.productDiameter
    if (key in variant) {
        // Because e.g. color can be an object, we must check if our property is a flat value or an object.
        const property = variant[key as keyof RelatedProperties];
        const variantValue = typeof property === 'object' && property !== null ? property.key : property;
        return variantValue === value;
    }
};

export const getPerfectVariantMatch = (
    variants: ProductDetailViewModel[],
    relatedProperties: RelatedProperties
): ProductDetailViewModel | undefined =>
    variants.find(variant => {
        const entries = Object.entries(relatedProperties);
        const matches = entries.filter(([prop, value]) =>
            getVariantMatch(variant, prop as keyof RelatedProperties, value)
        );
        // If our matches length equals our entries length, we know all properties on the current variant fits, and we got a perfect match.
        return matches.length === entries.length;
    });
